import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './IconButton.module.css';

type IconButtonVariant = 'default' | 'ghost';
type IconButtonSize = 'sm' | 'md' | 'lg';

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: IconButtonVariant;
  size?: IconButtonSize;
  label: string; // For accessibility
  children: ReactNode;
}

export const IconButton = ({
  variant = 'default',
  size = 'md',
  label,
  children,
  className = '',
  disabled,
  ...props
}: IconButtonProps) => {
  const classNames = [
    styles.iconButton,
    styles[variant],
    styles[size],
    className,
  ].filter(Boolean).join(' ');

  return (
    <button
      className={classNames}
      disabled={disabled}
      aria-label={label}
      {...props}
    >
      {children}
    </button>
  );
};

